export default function ForwardArrowIcon() {
  return (
    <>
      <path
        d='M6.62839 16.5984L12.0617 11.1651C12.7034 10.5234 12.7034 9.47344 12.0617 8.83177L6.62839 3.39844'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
